// Module
var code = `<div class="resize-splitter{{isHorizontal ? ' _horizontal':' _vertical'}}{{isVisible ? '' : '  _hidden'}}{{isDragged ? ' active' : ''}}" style="{{isHorizontal ? 'height:' + size + 'px' : 'width: ' + size + 'px'}}">
    {{#if withIcon}}
        <div class="resize-splitter-icon">
            <svg>
                <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#moveSeparatorHorizontal"></use>
            </svg>
        </div>
    {{/if}}
</div>`;
// Exports
export default code;